// extracted by mini-css-extract-plugin
module.exports = {"DoubleBorderScreenSkin":"_2JIKi","doubleBorderScreenSkin":"_2JIKi","bg":"_1Fcy7","doubleBorderContainer":"_25jza"};